module.exports = __webpack_public_path__ + "img/conectx-bg-landscape.1d1f45b4.jpg";